import React from 'react';

export default function LampIcon({ size = 40, color = '#AE9648' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Lamp body */}
      <ellipse cx="20" cy="28" rx="10" ry="4" stroke={color} strokeWidth="1.2" fill="none" opacity="0.5"/>
      <path d="M10 28 Q8 20 12 16 Q16 12 20 13 Q24 12 28 16 Q32 20 30 28" stroke={color} strokeWidth="1.4" fill="none" strokeLinecap="round"/>
      {/* Spout */}
      <path d="M10 24 Q6 22 5 20 Q4 18 7 17 Q9 16.5 10 18" stroke={color} strokeWidth="1.2" fill="none" strokeLinecap="round"/>
      {/* Handle */}
      <path d="M30 22 Q35 20 35 24 Q35 28 30 27" stroke={color} strokeWidth="1.2" fill="none" strokeLinecap="round"/>
      {/* Genie smoke wisps */}
      <path d="M20 13 Q22 9 20 6 Q18 3 20 1" stroke={color} strokeWidth="1.2" fill="none" strokeLinecap="round" opacity="0.7"/>
      <path d="M18 11 Q15 8 16 5" stroke={color} strokeWidth="0.9" fill="none" strokeLinecap="round" opacity="0.4"/>
      <path d="M22 11 Q25 8 24 5" stroke={color} strokeWidth="0.9" fill="none" strokeLinecap="round" opacity="0.4"/>
      {/* Shimmer dots */}
      <circle cx="20" cy="1" r="1" fill={color} opacity="0.6"/>
      <circle cx="16" cy="4.5" r="0.7" fill={color} opacity="0.35"/>
      <circle cx="24" cy="4.5" r="0.7" fill={color} opacity="0.35"/>
    </svg>
  );
}
